import { encodeBase64 } from '../encode';

export const encodeHeaderStringBase64 = (id: string, passphrase?: string) => {
  let headerString = `${id}`;

  if (passphrase) {
    headerString = `${id}:${passphrase}`;
  }

  return encodeBase64(headerString);
};
